import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVehicle } from "./type";
import { RequestStatus } from "@app/constants";

const initialState: IVehicle = {
  addWishlist: {},
  getWishlist: {},
  deleteWishlist: {},
};

const slice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    addWishlist(state, action: PayloadAction<any>) {
      state.addWishlist.status = RequestStatus.RUNNING;
    },
    addWishlistSuccess(state, action) {
      state.addWishlist.status = RequestStatus.SUCCESS;
      state.addWishlist.data = action.payload;
    },
    addWishlistFailed(state, action: PayloadAction<any>) {
      state.addWishlist.status = RequestStatus.ERROR;
      state.addWishlist.error = action.payload;
    },
    getWishlist(state, action: PayloadAction<any>) {
      state.getWishlist.status = RequestStatus.RUNNING;
    },
    getWishlistSuccess(state, action) {
      state.getWishlist.status = RequestStatus.SUCCESS;
      state.getWishlist.data = action.payload;
    },
    getWishlistFailed(state, action: PayloadAction<any>) {
      state.getWishlist.status = RequestStatus.ERROR;
      state.getWishlist.error = action.payload;
    },
    deleteWishlist(state, action: PayloadAction<any>) {
      state.deleteWishlist.status = RequestStatus.RUNNING;
    },
    deleteWishlistSuccess(state, action) {
      state.deleteWishlist.status = RequestStatus.SUCCESS;
      state.deleteWishlist.data = action.payload;
    },
    deleteWishlistFailed(state, action: PayloadAction<any>) {
      state.deleteWishlist.status = RequestStatus.ERROR;
      state.deleteWishlist.error = action.payload;
    },
  },
});

export default slice.reducer;
export const {
  addWishlist,
  addWishlistFailed,
  addWishlistSuccess,
  deleteWishlist,
  deleteWishlistFailed,
  deleteWishlistSuccess,
  getWishlist,
  getWishlistFailed,
  getWishlistSuccess,
} = slice.actions;
